import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module17World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../../Unit4/Module17/Kite/KitePractice';
import SingingTime from '../../SingingTime/SingingTime';
import FollowTheBeatModule7 from '../../FollowTheBeat/FollowTheBeatModule7';
import PracticeRecording from '../../Unit4/Practice/PracticeRecording';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';
import { UploadPhoto } from '../../s3Func/s3Upload';

const Module17World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module17 } = useSelector((state) => state.module17, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/newDesign/Unit4World17/Unit4Module17WorldNoLamp.png');
  const animal = generateImageUrl('images/Module2Images/Dog.png');
  const dog = generateImageUrl('images/Module2Images/Dog+Still.gif');
  const progressbar0 = generateImageUrl('images/Module2Images/EmptyBone.png');
  const progressbar1 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar2 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar3 = generateImageUrl('images/Module2Images/Bone2outof3.png');
  const progressbarCompleted = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const coin = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const dirtCloud = generateImageUrl('images/Module2Images/Dirt+cloud.png');
  const StandPopsicle = generateImageUrl('images/Module17Images/StandPopsicle.png');
  const StandChurros = generateImageUrl('images/Module17Images/StandChurros.png');
  const Hat = generateImageUrl('images/Module17Images/Hat.png');
  const Bow = generateImageUrl('images/Module17Images/Bow.png');
  const ButterflyPink = generateImageUrl('images/Module17Images/ButterflyPink.png');
  const ButterflyBlue = generateImageUrl('images/Module17Images/ButterflyBlue.png');
  const PlaygroundBlue = generateImageUrl('images/Module17Images/PlaygroundBlue.png');
  const PlaygroundRed = generateImageUrl('images/Module17Images/PlaygroundRed.png');
  const Baseball = generateImageUrl('images/Module17Images/Baseball.png');
  const Ball = generateImageUrl('images/Module17Images/Ball.png');
  const PondMallardDuck = generateImageUrl('images/Module17Images/DailyReward_Pond1@3x.png');
  const PondWhiteDuck = generateImageUrl('images/Module17Images/DailyReward_Pond2@3x.png');
  const KitePink = generateImageUrl('images/Module17Images/KitePink.png');
  const KitePurple = generateImageUrl('images/Module17Images/KitePurple.png');
  const SkateboardRed = generateImageUrl('images/Module17Images/SkateboardRed.png');
  const SkateboardBlue = generateImageUrl('images/Module17Images/SkateboardBlue.png');
  const DogInBlue = generateImageUrl('images/Module17Images/DogInBlue.png');
  const DogInRed = generateImageUrl('images/Module17Images/DogInRed.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'a025a6293ba41375503722d6171a/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);
  const [playDiggingAudio, setPlayDiggingAudio] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [practice, setPractice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [playDogCelebrate, setPlayDogCelebrate] = useState(false);
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [dogState, setDogState] = useState(dog);
  const [dirtState, setDirtState] = useState(false);
  const [playDigging, setPlayDigging] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial1_2, setFTBTutorial1_2] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [amazingJobDog, setAmazingJobDog] = useState('');
  const [answerSpecialMessage, setAnswerSpecialMessage] = useState('');
  const [answerWatch, setAnswerWatch] = useState('');
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [followTheBeatIntro, setFollowTheBeatIntro] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [dogDig, setDogDig] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  function getGifs() {
    setAmazingJobDog(getVideo('appfiles/answer/answer_amazing_job.gif', login));
    setDogDig(getVideo('appfiles/listening/dog_dig.gif', login));
    setCelebrateIntro(getVideo('appfiles/answer/answer_celebrate_intro.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/friends_bullying/friends_bullying_day_finished.mp3', login));
    setLearnIntro(getVideo('appfiles/answer/answer_learn_intro.gif', login));
    setPracticeIntro(getVideo('appfiles/answer/answer_practice_intro.gif', login));
    setAnswerSpecialMessage(getVideo('appfiles/answer/answer_practice_special_message.gif', login));
    setAnswerWatch(getVideo('appfiles/answer/answer_practice_watch_conversation.gif', login));
    setFollowTheBeatIntro(getVideo('appfiles/answer/answer_ftb_intro.gif', login));
    setAnimalClose(getVideo('appfiles/answer/answer_day_finished.gif', login));

    setFTBInstruction(getVideo('appfiles/friends_bullying/friends_bullying_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/answer/answer_ftb_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/answer/answer_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/answer/countingDog.gif', login));

    if (!module17.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/friends_bullying/ftb_walkthrough_touch_right_clap.mp3', login));
      setFTBTutorial1_2(getVideo('appfiles/friends_bullying/ftb_walkthrough_touch_left_clap.mp3', login));
      setFTBTutorial2(getVideo('appfiles/manners/ftb_walkthrough_together.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/answer/ftb_walkthrough_audio.mp3', login));
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const createGameDetails = (flag, reward, coin) => {
    const game_detail = module17.game_details;
    if (flag) {
      const flags = { flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.psuh(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      const dailyRewards = [];
      for (const key in module17.rewards) {
        if (module17.rewards[key].unlocked === true) {
          const rewards = {
            type: key,
            x_multiplier: module17.rewards[key].x,
            y_multiplier: module17.rewards[key].y,
          };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: 'MODULE17_SET_GameDetials', payload: game_detail });
  };

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "FriendsBullies",
				day_completed: module17.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = async () => {
    const myInit = {
      body: {
        id: module17.moduleID,
        day_completed: module17.day_completed,
        step_completed: module17.stepCompleted,
        game_details: JSON.stringify(module17.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayDogCelebrate(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module17.stepCompleted === 'notstarted' ||
          module17.stepCompleted === 'learn' ||
          module17.stepCompleted === 'practice' ||
          module17.stepCompleted === 'celebrate' ||
          module17.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'FriendsBullies',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    getGifs();
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module17.stepCompleted]);

    useEffect(() => {
      if((module17.reviewIcon === true || login.grade === "Teacher Mode") && module17.sectionCompleted === 4 ) {
          updateProgress();
          module17.sectionCompleted = 0;
      }
    }, [module17.sectionCompleted])

  useEffect(() => {
    if (module17.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module17.coins);
      updateDB();
    }
  }, [module17.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module17.currentday <= module17.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE17_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE17_SET_KEY', payload: 4 });
      if (module17.currentday === 4 || module17.currentday === 8) {
        dispatch({ type: 'MODULE17_SET_KEY', payload: 5 });
      }
    } else {
      if (module17.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE17_TOGGLE_REVIEW_ICON', payload: false });
      if (module17.currentday === 4 && module17.day_completed === 3) {
        if (module17.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 0 });

        } else if (module17.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 1 });

        } else if (module17.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 2 });

        } else if (module17.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 3 });

        } else if (module17.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 4 });
        } else if (module17.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE17_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module17.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 0 });

        } else if (module17.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 1 });

        } else if (module17.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 2 });

        } else if (module17.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 3 });

        } else if (module17.stepCompleted === 'celebrate') {
          if (module17.currentday === 8 && module17.day_completed === 7) {
            dispatch({ type: 'MODULE17_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE17_SET_KEY', payload: 4 });
          }
        } else if (module17.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE17_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module17.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);
  let [displayRewardVideo, setDisplayRewardVideo] = useState(false);
  let [rewardVideo, setRewardVideo] = useState('');

  const selectReward = () => {
    return (
      <>
        <div className='rewards'  id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE17_SET_REWARD${module17.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE17_SET_REWARD${module17.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE17_SET_REWARD${module17.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE17_SET_REWARD${module17.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE17_SET_DAY_UNLOCK${module17.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE17_SET_dayCompleted',
                    payload: module17.currentday === 8 ? 9 : module17.currentday,
                  });
                  dispatch({
                    type: 'MODULE17_SET_stepCompleted',
                    payload: 'notstarted',
                  }); // change this back to notstarted
                });
              }}
              onError={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  dispatch({
                    type: `MODULE17_SET_DAY_UNLOCK${module17.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE17_SET_dayCompleted',
                    payload: module17.currentday === 8 ? 9 : module17.currentday,
                  });
                  dispatch({
                    type: 'MODULE17_SET_stepCompleted',
                    payload: 'notstarted',
                  }); // change this back to notstarted
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                let name = '';
                switch (module17.currentday){
                  case 1:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Outfit2_1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Outfit2.mp4'
                    }
                    break;
                  case 2:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Kite1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Kite2.mp4'
                    }
                    break;
                  case 3:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Butterfly1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Butterfly2.mp4'
                    }
                    break;
                  case 4:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Playgorund1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Playground2.mp4'
                    }
                    break;
                  case 5:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Baseball.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Baseball2.mp4'
                    }
                    break;
                  case 6:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Pond1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Pond2.mp4'
                    }
                    break;
                  case 7:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Snack1.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Snack2.mp4'
                    }
                    break;
                  case 8:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Skate2.mp4'
                    }
                    else{
                      name = 'media/Module17/Unit4_Mod1_DailyReward_Skate1.mp4'
                    }
                    break;
                }
                setRewardVideo(generateImageUrl(name))
                document.getElementById('rewardItemLeft2').style.display = 'none'
                document.getElementById('rewardItemRight2').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={DogInBlue}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE17_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE17_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={DogInRed}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE17_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE17_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE17_SET_COIN',
                    payload: module17.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              onError={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE17_SET_COIN',
                    payload: module17.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                  setRewardVideo(generateImageUrl('media/Module17/Unit4_Mod2_Special Dance 2.mp4'))
                }
                else{
                  setRewardVideo(generateImageUrl('media/Module17/Unit4_Mod2_Special Dance 1.mp4'))
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module17.currentday) {
      case 1:
        setRewardOption1(Hat);
        setRewardOption2(Bow);
        break;
      case 2:
        setRewardOption1(KitePurple);
        setRewardOption2(KitePink);
        break;
      case 3:
        setRewardOption1(ButterflyBlue);
        setRewardOption2(ButterflyPink);
        break;
      case 4:
        setRewardOption1(PlaygroundBlue);
        setRewardOption2(PlaygroundRed);
        break;
      case 5:
        setRewardOption1(Baseball);
        setRewardOption2(Ball);
        break;
      case 6:
        setRewardOption1(PondMallardDuck);
        setRewardOption2(PondWhiteDuck);
        break;
      case 7:
        setRewardOption1(StandChurros);
        setRewardOption2(StandPopsicle);
        break;
      case 8:
        setRewardOption1(SkateboardRed);
        setRewardOption2(SkateboardBlue);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module17.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/friendsbullies/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module17.currentday === 4) {
              dispatch({ type: 'MODULE17_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module17.day_completed === 9) {
              navigate('/friendsbullies/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/friends_bullying/friends_bullying_demo.m4a', login);
    let video = getVideo('appfiles/friends_bullying/learn_video.mp4', login);
    switch (module17.currentday) {
      case 1:
        setLearn(
          <Learn
            video='c1078258c25f0cbbd0f9f39d93e2/480.m3u8'
            songVideo={video}
            closingVideo='dcefb5e94324eb1557859a2f606b/480.m3u8'
            destiny='/friendsbullies'
            song={song}
            back='/friendsbullies'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE17_SET_stepCompleted'
            module={module17}
            module17={true}
            animal={dog}
            learnVideo1={'d3996c98d75bfe5e903f651715f5/480.m3u8'}
            learnVideo2={'fdcf5f4ec24ead621e2bd779da60/480.m3u8'}
            learnVideo3={'bcd0a87c76a6109e994617098a78/480.m3u8'}
          />
        );
        break;
      case 2:
              setLearn(
          <Learn
            video='Module17/learn_day2.mp4'
            songVideo={video}
            closingVideo='1f2ca4848d225272e797e27c54c0/480.m3u8'
            destiny='/friendsbullies'
            song={song}
            back='/friendsbullies'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE17_SET_stepCompleted'
            module={module17}
            module17={true}
            animal={dog}
            learnVideo1={'e916c4595425134dd9a38f185307/480.m3u8'}
            learnVideo2={'b3feb1b70a4df145d367bd22989b/480.m3u8'}
            learnVideo3={'b6c34c4cc65bd9c867b770a9f04e/480.m3u8'}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='9fb5640801b43603352a5c1567c1/480.m3u8'
            songVideo={video}
            closingVideo='86a4d7802d9e822b68bd7999fdc9/480.m3u8'
            destiny='/friendsbullies'
            song={song}
            back='/friendsbullies'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE17_SET_stepCompleted'
            module={module17}
            module17={true}
            animal={dog}
            learnVideo1={'60d5e56e2b1cdf83cdd26657f5ec/480.m3u8'}
            learnVideo2={'023d11baafc499c578865dc531f8/480.m3u8'}
            learnVideo3={'ce536e1d2269157c6b462d784596/480.m3u8'}
          />
        );
        break;
      default:
        setShowAnimal(true);
        setAnimalState(learnIntro);
        setAnimalVoice(getVideo('appfiles/friends_bullying/friends_bullying_learn_intro.mp3', login));
        // setDisplayVoice(true)
        GetUserVideo(`userfiles/${module17.StudentID}/friends_bullies_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module17.currentday - 4]}/answer_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/friendsbullies'
                    song={data}
                    back='/friendsbullies'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE17_SET_stepCompleted'
                    module={module17}
                    instrumental={getVideo('appfiles/friends_bullying/friends_bullying_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/friendsbullies'
                    song={song}
                    back='/friendsbullies'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE17_SET_stepCompleted'
                    module={module17}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    switch (module17.currentday) {
      case 1:
        setPractice(
          <Practice
            video1={'da3ab8e646e235f0211a8683d6d6/480.m3u8'}
            video2={'7ec1083d916edc2b80b83746e305/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE17_SET_stepCompleted'}
            module={module17}
            animal={dog}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            video1={'8fd651f6b0fff265d92a8abc74cc/480.m3u8'}
            video2={'7ec1083d916edc2b80b83746e305/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE17_SET_stepCompleted'}
            module={module17}
            animal={dog}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            video1={'10a3bdea90fa54c49f6ea138cfe9/480.m3u8'}
            video2={'7ec1083d916edc2b80b83746e305/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE17_SET_stepCompleted'}
            module={module17}
            animal={dog}
          />
        );
        break;
      default:
        
        const optionBullyStop = {
            img: generateImageUrl('images/Module17Images/practice/tell the bully to stop.png'),
            title: 'Tell the bully to stop',
            audioPrompt: 'appfiles/friends_bullying/option_tell_bully_stop.mp3',
        };
        
        const optionWalkAway = {
            img: generateImageUrl('images/Module17Images/practice/walk away and stay away.png'),
            title: 'Walk away and stay away',
            audioPrompt: 'appfiles/friends_bullying/option_walk_away.mp3',
        };
        
        const optionTellAdult = {
            img: generateImageUrl('images/Module17Images/practice/tell a safe adult.png'),
            title: 'Tell an adult',
            audioPrompt: 'appfiles/friends_bullying/option_tell_adult.mp3',
        };

        const optionHelp = {
          img: generateImageUrl('images/Module17Images/practice/help him.png'),
          title: 'Help him',
          audioPrompt: 'appfiles/friends_bullying/option_help.mp3',
        };
        
        const optionSmileHi = {
            img: generateImageUrl('images/Module17Images/practice/smile and say hi.png'),
            title: 'Smile and say hi',
            audioPrompt: 'appfiles/friends_bullying/option_smile_hi.mp3',
        };
        
        const optionFrown = {
            img: generateImageUrl('images/Module17Images/practice/frown.png'),
            title: 'Frown',
            audioPrompt: 'appfiles/friends_bullying/option_frown.mp3',
        };
        
        const optionWhatLike = {
            img: generateImageUrl('images/Module17Images/practice/what do you like.png'),
            title: 'What do you like?',
            audioPrompt: 'appfiles/friends_bullying/option_what_like.mp3',
        };
        
        const optionWhySad = {
            img: generateImageUrl('images/Module17Images/practice/why are you sad.png'),
            title: 'Why are you sad?',
            audioPrompt: 'appfiles/friends_bullying/option_why_sad.mp3',
        };
        
        const optionIgnore = {
            img: generateImageUrl('images/Module17Images/practice/ignore them.png'),
            title: 'Ignore your friend',
            audioPrompt: 'appfiles/friends_bullying/option_ignore.mp3',
        };
        
        const optionWhereGoing = {
            img: generateImageUrl('images/Module17Images/practice/where are you going.png'),
            title: 'Where are you going?',
            audioPrompt: 'appfiles/friends_bullying/option_where_going.mp3',
        };
        
        const optionSorryNervous = {
            img: generateImageUrl('images/Module17Images/practice/I_m sorry you feel nervous.png'),
            title: "I'm sorry you feel nervous",
            audioPrompt: 'appfiles/friends_bullying/option_sorry_nervous.mp3',
        };
        
        const optionGiveUp = {
            img: generateImageUrl('images/Module17Images/practice/just give up.png'),
            title: 'Just give up',
            audioPrompt: 'appfiles/friends_bullying/option_give_up.mp3',
        };
        
        const optionNeverNervous = {
            img: generateImageUrl('images/Module17Images/practice/I never feel nervous.png'),
            title: 'I never feel nervous',
            audioPrompt: 'appfiles/friends_bullying/option_never_nervous.mp3',
        };
        
        const optionLikeBaseball = {
            img: generateImageUrl('images/Module17Images/practice/do you like baseball.png'),
            title: 'Do you like baseball?',
            audioPrompt: 'appfiles/friends_bullying/option_like_baseball.mp3',
        };
        
        const optionLikeEat = {
            img: generateImageUrl('images/Module17Images/practice/what do you like to eat.png'),
            title: 'What do you like to eat?',
            audioPrompt: 'appfiles/friends_bullying/option_like_eat.mp3',
        };
        
        const optionRocksSticks = {
            img: generateImageUrl('images/Module17Images/practice/do you want to skip rocks or float sticks.png'),
            title: 'Do you want to skip rocks or float sticks?',
            audioPrompt: 'appfiles/friends_bullying/option_rock_stick.mp3',
        };
        
        const optionBandaid = {
            img: generateImageUrl('images/Module17Images/practice/get a bandaid.png'),
            title: 'Get a bandaid',
            audioPrompt: 'appfiles/friends_bullying/option_bandaid.mp3',
        };
        
        const optionListenMusic = {
            img: generateImageUrl('images/Module17Images/practice/listen to music.png'),
            title: 'Listen to music',
            audioPrompt: 'appfiles/friends_bullying/option_listen_music.mp3',
        };
        
        const optionGetNew = {
            img: generateImageUrl('images/Module17Images/practice/get them a new one.png'),
            title: 'Get them a new one',
            audioPrompt: 'appfiles/friends_bullying/option_get_new.mp3',
        };
        
        const optionLaugh = {
            img: generateImageUrl('images/Module17Images/practice/laugh at them.png'),
            title: 'Laugh at them',
            audioPrompt: 'appfiles/friends_bullying/option_laugh.mp3',
        };
        
        const optionSkateboard = {
            img: generateImageUrl('images/Module17Images/practice/do you like to skateboard.png'),
            title: 'Do you like to skateboard?',
            audioPrompt: 'appfiles/friends_bullying/option_skateboard.mp3',
        };

        const friendGreet = {
          prompt: 'If you see your friend at the playground, you should',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_greet.mp3',
          correctMatch: optionSmileHi,
          incorrectMatches: [optionFrown, optionIgnore],
        };

        const friendLike = {
          prompt: 'If you want to know what your friend likes, you can ask',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_likes.mp3',
          correctMatch: optionWhatLike,
          incorrectMatches: [optionWhySad, optionWhereGoing],
        };

        const friendNervous = {
          prompt:
            'If your friend tells you that he feels nervous when he gets up to bat, you should say',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_nervous.mp3',
          correctMatch: optionSorryNervous,
          incorrectMatches: [optionGiveUp, optionNeverNervous],
        };

        const friendBaseball = {
          prompt:
            'If you want to learn if your friend likes baseball, you can ask',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_baseball.mp3',
          correctMatch: optionLikeBaseball,
          incorrectMatches: [optionWhySad, optionWhereGoing],
        };

        const friendTrip = {
          prompt: 'If your friend trips and falls, you can',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_trip.mp3',
          correctMatch: optionBandaid,
          incorrectMatches: [optionIgnore, optionListenMusic],
        };

        const friendPlay = {
          prompt:
            'If you want to know what your friend wants to play, you can ask',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_play.mp3',
          correctMatch: optionRocksSticks,
          incorrectMatches: [optionWhySad, optionWhereGoing],
        };

        const friendNapkin = {
          prompt: 'If your friend drops their napkin, you can',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_napkin.mp3',
          correctMatch: optionGetNew,
          incorrectMatches: [optionGiveUp, optionIgnore],
        };

        const friendFoodLike = {
          prompt:
            'If you want to know what food your friend likes, you can ask',
          audioPrompt:
            'appfiles/friends_bullying/scenario_friend_food_like.mp3',
          correctMatch: optionLikeEat,
          incorrectMatches: [optionWhySad, optionWhereGoing],
        };

        const friendFall = {
          prompt: 'If your friend trips and falls, you should',
          audioPrompt: 'appfiles/friends_bullying/scenario_friend_fall.mp3',
          correctMatch: optionHelp,
          incorrectMatches: [optionLaugh, optionIgnore],
        };

        const friendSkateboard = {
          prompt:
            'If you want to know if your friend likes to skateboard, you can ask',
          audioPrompt:
            'appfiles/friends_bullying/scenario_friend_skateboard.mp3',
          correctMatch: optionSkateboard,
          incorrectMatches: [optionWhySad, optionWhereGoing],
        };

        const bullyMatch = [
          {
            prompt:
              'Someone is telling lies about you to other people. What should you do? Put the steps in order.',
            audioPrompt: 'appfiles/friends_bullying/scenario_bully_practice.mp3',
          },
          {
            prompt:
              'Someone tries to trip you every time you walk by. What should you do? Put the steps in order.',
            audioPrompt:
              'appfiles/friends_bullying/scenario_bully_baseball.mp3',
          },
          {
            prompt:
              'Someone laughs at you every time you try to skip a rock. What should you do? Put the steps in order.',
            audioPrompt: 'appfiles/friends_bullying/scenario_bully_pond.mp3',
          },
          {
            prompt:
              'Someone takes your food over and over again without asking. What should you do? Put the steps in order.',
            audioPrompt: 'appfiles/friends_bullying/scenario_bully_snack.mp3',
          },
          {
            prompt:
              'Someone keeps making fun of your skateboard. What should you do? Put the steps in order.',
            audioPrompt:
              'appfiles/friends_bullying/scenario_bully_skatepark.mp3',
          },
        ];

        const names = [
          [
            'friends_bullies_practice_greet_5.mp4',
            'friends_bullies_practice_ask_5.mp4',
            'friends_bullies_practice_respond_5.mp4',
            'friends_bullies_practice_answer_5.mp4',
          ],
          [
            'friends_bullies_practice_greet_6.mp4',
            'friends_bullies_practice_ask_6.mp4',
            'friends_bullies_practice_respond_6.mp4',
            'friends_bullies_practice_answer_6.mp4',
          ],
          [
            'friends_bullies_practice_greet_7.mp4',
            'friends_bullies_practice_ask_7.mp4',
            'friends_bullies_practice_respond_7.mp4',
            'friends_bullies_practice_answer_7.mp4',
          ],
          [
            'friends_bullies_practice_greet_8.mp4',
            'friends_bullies_practice_ask_8.mp4',
            'friends_bullies_practice_respond_8.mp4',
            'friends_bullies_practice_answer_8.mp4',
          ],
          [
            'friends_bullies_practice_greet_9.mp4',
            'friends_bullies_practice_ask_9.mp4',
            'friends_bullies_practice_respond_9.mp4',
            'friends_bullies_practice_answer_9.mp4',
          ],
        ];
        const options = [
          [friendGreet, friendLike, bullyMatch[0]],
          [friendNervous, friendBaseball, bullyMatch[1]],
          [friendTrip, friendPlay, bullyMatch[2]],
          [friendNapkin, friendFoodLike, bullyMatch[3]],
          [friendFall, friendSkateboard, bullyMatch[4]],
        ];
        const titles = [
          'Step 1: Be Kind',
          'Step 2: Ask Questions',
          'How to Stop Bullying',
        ];
        const instructions = [
          [
            'appfiles/friends_bullying/practice_playground_intro.mp4',
            'appfiles/friends_bullying/practice_playground_greet.mp4',
            'appfiles/friends_bullying/practice_playground_answer.mp4',
            'appfiles/friends_bullying/practice_playground_ask.mp4',
            'appfiles/friends_bullying/practice_playground_respond.mp4',
          ],
          [
            'appfiles/friends_bullying/practice_baseball_intro.mp4',
            'appfiles/friends_bullying/practice_baseball_greet.mp4',
            'appfiles/friends_bullying/practice_baseball_answer.mp4',
            'appfiles/friends_bullying/practice_baseball_ask.mp4',
            'appfiles/friends_bullying/practice_baseball_respond.mp4',
          ],
          [
            'appfiles/friends_bullying/practice_pond_intro.mp4',
            'appfiles/friends_bullying/practice_pond_greet.mp4',
            'appfiles/friends_bullying/practice_pond_answer.mp4',
            'appfiles/friends_bullying/practice_pond_ask.mp4',
            'appfiles/friends_bullying/practice_pond_respond.mp4',
          ],
          [
            'appfiles/friends_bullying/practice_snack_intro.mp4',
            'appfiles/friends_bullying/practice_snack_greet.mp4',
            'appfiles/friends_bullying/practice_snack_answer.mp4',
            'appfiles/friends_bullying/practice_snack_ask.mp4',
            'appfiles/friends_bullying/practice_snack_respond.mp4',
          ],
          [
            'appfiles/friends_bullying/practice_skateboard_intro.mp4',
            'appfiles/friends_bullying/practice_skateboard_greet.mp4',
            'appfiles/friends_bullying/practice_skateboard_answer.mp4',
            'appfiles/friends_bullying/practice_skateboard_ask.mp4',
            'appfiles/friends_bullying/practice_skateboard_respond.mp4',
          ],
        ];
        const texts = [
          [
            `Press record and say, "Hi! What is your name?"`,
            `Press record and say, "What is your favorite subject at school?"`,
            `Press record and say, "That is a great subject!"`,
            `Press record and say your favorite subject in school.`,
          ],
          [
            `Press record and say, "Hi! What is your name?"`,
            `Press record and say, "What is your favorite thing to do outside?"`,
            `Press record and say, "That is awesome!"`,
            `Press record and say your favorite thing to do outside.`,
          ],
          [
            `Press record and say, "Hi! What is your name?"`,
            `Press record and say, "What animal do you like?"`,
            `Press record and say, "Cool!"`,
            `Press record and say what animal you like.`,
          ],
          [
            `Press record and say, "Hi! What is your name?"`,
            `Press record and say, "What is your favorite food?"`,
            `Press record and say, "That is a good choice!"`,
            `Press record and say your favorite food.`,
          ],
          [
            `Press record and say, "Hi! What is your name?"`,
            `Press record and say, "What do you like to do?"`,
            `Press record and say, "Fun!"`,
            `Press record and say what you like to do.`,
          ],
        ];
        const voices = [
          [
            'appfiles/friends_bullying/practice_playground_greet.mp3',
            'appfiles/friends_bullying/practice_playground_ask.mp3',
            'appfiles/friends_bullying/practice_playground_respond.mp3',
            'appfiles/friends_bullying/practice_playground_answer.mp3',
          ],
          [
            'appfiles/friends_bullying/practice_playground_greet.mp3',
            'appfiles/friends_bullying/practice_baseball_ask.mp3',
            'appfiles/friends_bullying/practice_baseball_respond.mp3',
            'appfiles/friends_bullying/practice_baseball_answer.mp3',
          ],
          [
            'appfiles/friends_bullying/practice_playground_greet.mp3',
            'appfiles/friends_bullying/practice_pond_ask.mp3',
            'appfiles/friends_bullying/practice_pond_respond.mp3',
            'appfiles/friends_bullying/practice_pond_answer.mp3',
          ],
          [
            'appfiles/friends_bullying/practice_playground_greet.mp3',
            'appfiles/friends_bullying/practice_snack_ask.mp3',
            'appfiles/friends_bullying/practice_snack_respond.mp3',
            'appfiles/friends_bullying/practice_snack_answer.mp3',
          ],
          [
            'appfiles/friends_bullying/practice_playground_greet.mp3',
            'appfiles/friends_bullying/practice_skateboard_ask.mp3',
            'appfiles/friends_bullying/practice_skateboard_respond.mp3',
            'appfiles/friends_bullying/practice_skateboard_answer.mp3',
          ],
        ];
        const exampleVideos = [
          'e294350f0903d692904e2d120bd2/480.m3u8',
          '20e09d03369321476cb731f8bc8e/480.m3u8',
          'abb95df072889cc1482d42c212fa/480.m3u8',
          '0a653ee421546c268cd682d894f9/480.m3u8',
          'bc6f2aaa640b56c6ca88d64e2718/480.m3u8',
        ];
        setAnimalVoice(getVideo('appfiles/friends_bullying/friends_bullying_practice_intro.mp3', login));
        // setDisplayVoice(true);
        setAnimalState(practiceIntro);
        setShowAnimal(true);
        setPractice(
          <PracticeRecording
            score={'practice_friends_bullies'}
            score_target={5}
            options={options[module17.currentday - 4]}
            titles={titles}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE17_SET_stepCompleted'}
            module={module17}
            animal={dog}
            module17={true}
            instructions={instructions[module17.currentday - 4]}
            matchOptions={[optionBullyStop, optionTellAdult, optionWalkAway]}
            names={names[module17.currentday - 4]}
            texts={texts[module17.currentday - 4]}
            voices={voices[module17.currentday - 4]}
            influencerid={influencers[module17.currentday - 4]}
            introduction={practiceIntro}
            introductionMP3={
              'appfiles/friends_bullying/practice_conversation.mp3'
            }
            practiceConversation={answerWatch}
            practiceMessage={answerSpecialMessage}
            awesomeJob={amazingJobDog}
            practiceConversationAudio={'appfiles/answer/answer_practice_watch_conversation.mp3'}
            practiceMessageAudio={'appfiles/answer/answer_practice_special_message.mp3'}
            awesomeJobAudio={'appfiles/answer/answer_amazing_job.mp3'}
            exampleVideo={exampleVideos[module17.currentday - 4]}
          />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    switch (module17.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

      default:
        setShowAnimal(true);
        setAnimalState(followTheBeatIntro);
        setAnimalVoice(getVideo('appfiles/answer/answer_ftb_intro.mp3', login));
        // setDisplayVoice(true)
        break;
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'Module17/celebrate_intro.mp4';
    const celebrateVideo2 = 'Module17/celebrate_intro.mp4';
    const celebrateVideo3 = 'Module17/celebrate_intro.mp4';

    switch (module17.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module17}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE17'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module17}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE17'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module17}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE17'}
          />
        );
        break;
      default:
        let audios = ['appfiles/friends_bullying/friends_bullying_celebrate_record_kind.mp3',
        'appfiles/friends_bullying/friends_bullying_celebrate_record_questions.mp3',
        'appfiles/friends_bullying/friends_bullying_celebrate_record_not_bully.mp3',
        'appfiles/friends_bullying/friends_bullying_celebrate_record_stop_bullying.mp3',
        'appfiles/friends_bullying/friends_bullying_celebrate_record_making_friends.mp3']
        let text = [`Record yourself in an excited voice and say, "I am amazing because I am kind!"`,
        `Record yourself in an excited voice and say, "I am amazing because I ask good questions!"`,
        `Record yourself in an excited voice and say, "I am amazing because I do not bully others!"`,
        `Record yourself in an excited voice and say, "I am amazing because I tell others to stop bullying!"`,
        `Record yourself in an excited voice and say, "I am amazing because I am good at making friends!"`]
        setShowAnimal(true);
        setAnimalVoice(getVideo('appfiles/answer/answer_celebrate_intro.mp3', login));
        // setDisplayVoice(true)
        setAnimalState(celebrateIntro);
        let voice1 = getVideo(audios[module17.currentday-4], login);
        let voice2 = getVideo('appfiles/answer/answer_celebrate_say_thanks.mp3', login);
        let voice3 = getVideo('appfiles/answer/answer_amazing_job.mp3', login);
        let animalGIF = getVideo('appfiles/understand_feelings/understand_feelings_joyful.gif', login);
        let animalVoice = getVideo('appfiles/understand_feelings/understand_feelings_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module17.currentday - 4]}/answer_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module17}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={text[module17.currentday-4]}
              name={`friends_bullying_celebration_surprise_${
                module17.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJobDog}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE17'}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '5cc4f0e26d2b1b729a5ff72f3c5b/480.m3u8';
    let noteVideo = getVideo('appfiles/friends_bullying/friends_bullying_student_notes.mp4', login)
    let singingMusic = getVideo('appfiles/friends_bullying/friends_bullying_demo.m4a', login)
    let instrumental = getVideo('appfiles/friends_bullying/friends_bullying_instrumental.m4a', login)
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module17}
        moduleNum='MODULE17'
        name='friends_bullies'
        instrumental={instrumental}
        instrumentalURL={'appfiles/friends_bullying/friends_bullying_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_5.mp4`,
      },
      {
        video: 'appfiles/friends_bullying/practice_playground_intro.mp4',
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullies_practice_greet_5.mp4`,
      },
      {
        video: 'appfiles/friends_bullying/practice_playground_greet.mp4',
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullies_practice_ask_5.mp4`,
      },
      {
        video: 'appfiles/friends_bullying/practice_playground_answer.mp4',
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullies_practice_respond_5.mp4`,
      },
      {
        video: 'appfiles/friends_bullying/practice_playground_ask.mp4',
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullies_practice_answer_5.mp4`,
      },
      {
        video: 'appfiles/friends_bullying/practice_playground_respond.mp4',
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module17.StudentID}/friends_bullying_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/answer_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; ++i){
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
  
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/friends_bullying/friends_bullying_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      ); 
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const keyAnimation = () => {
    setRewardAnimationState('fade-out');
    sleep(1000).then(() => {
      diggingAnimation();
    });
  };

  const diggingAnimation = () => {
    setPlayDigging(true);
  };

  const playButtonAudio = () => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  };

  const closeDay8Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setShowAnimal(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE17_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE17_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayVoice(false);
        setShowAnimal(false);
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if(playDogCelebrate && isIOS()) {
      timer = setTimeout(() => {
        setPlayDogCelebrate(false);
        if(module17.currentday === 8) {
          closeDay8Video();
        } else {
          navigate('/friendsbullies/navigation');
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [playDogCelebrate]);

  useEffect(() => {
    let timer;
    if(coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE17_SET_COIN', payload: module17.coins + 1 });
        setCoinAudio(false);
        setCoinAnimationState('bounceIcons');
        setCoinIcon(false);
        playButtonAudio();
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [coinAudio]);

  useEffect(() => {
    let timer;
    if(playDiggingAudio && isIOS()) {
      setAudioReady(false);
      setPlayDigging(false);
      setDirtState(false);
      setPlayDiggingAudio(false);
      setKeyIcon(false);
      setDisplayReward(true);
      setRewardsFound(true);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [playDiggingAudio]);

  return (
    <>
      {playDogCelebrate && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayDogCelebrate(false);
            module17.currentday === 8
              ? closeDay8Video()
              : navigate('/friendsbullies/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {playDiggingAudio && (
        <audio
          autoPlay
          onPlay={() => {
            setDirtState(true);
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setPlayDigging(false);
            setDirtState(false);
            setPlayDiggingAudio(false);
            setKeyIcon(false);
            setDisplayReward(true);
            setRewardsFound(true);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module2Videos/dog_digging.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE17_SET_COIN',
              payload: module17.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {!showAnimal && displayPractice && practice}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule7
          unit4={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJobDog}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial1_2={ftbTutorial1_2}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE17_SET_stepCompleted'} 
          module={module17}
          score={'ftb_friends_bullies'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='understandfeelingsWorldBody'
          style={{ backgroundImage: `url(${generateImageUrl("images/newDesign/Unit4World17/Unit4Module17WorldNoLamp.png")})` }}
        >
          <img
            className='lamp'
            src={generateImageUrl("images/newDesign/Unit4World17/Unit4Module17LampPostOnly.png")}
            alt='lamp'
          />
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world Image'
              onClick={() => {
                navigate('/friendsbullies/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='dogGif17' src={dogState} alt='dog Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              className='dogGif17'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}
          {playDigging && (
            <img
              style={audioReady ? {} : { display: 'none' }}
              src={dogDig}
              className='dogGif17'
              onLoad={() => setPlayDiggingAudio(true)}
            />
          )}
          {dirtState && (
            <img
              className='dirt'
              src={dirtCloud}
              id='dirtAnimation'
              style={{
                position: 'absolute',
                zIndex: 2,
                top: '70%',
                left: '50%',
                height: '120px',
                width: '140px',
                marginTop: '90px',
                marginLeft: '-70px',
              }}
            ></img>
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'

            />
            {module17.coins < 10 && (
              <h5 className='scoretext1'>{module17.coins}</h5>
            )}
            {module17.coins >= 10 && module17.coins < 100 && (
              <h5 className='scoretext10'>{module17.coins}</h5>
            )}
            {module17.coins >= 100 && (
              <h5 className='scoretext100'>{module17.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module17.currentday === 4 || module17.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module17.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module17.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module17.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module17.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module17.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module17.currentday === 4 &&
                  module17.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module17.currentday !== 4 &&
                  module17.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module17.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}
                {module17.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}
                {module17.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}
                {module17.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {!module17.reviewIcon && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coin}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module17.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      setReviewIcon(!reviewIcon);
                    });
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          keyAnimation();
                        });
                      }}
                  />)}
                {module17.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {keyIcon && !coinIcon && !disPlayPrize && (
            <img
              className='rewardsIcon'
              style={{
                width: '150px',
                height: '50px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              id={rewardAnimationState}
              src={keyReward}
              alt='reward bone'
              onClick={() => {
                keyAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module17.rewards.StandPopsicle.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.StandPopsicle.x * clientWidth,
                  y: module17.rewards.StandPopsicle.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveCart2'
                  style={{ backgroundImage: `url(${StandPopsicle})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.StandChurros.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.StandChurros.x * clientWidth,
                  y: module17.rewards.StandChurros.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveCart1'
                  style={{ backgroundImage: `url(${StandChurros})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.Hat.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.Hat.x * clientWidth,
                  y: module17.rewards.Hat.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveCharaterReward17'
                  style={{ backgroundImage: `url(${Hat})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.Bow.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.Bow.x * clientWidth,
                  y: module17.rewards.Bow.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${Bow})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.ButterflyBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.ButterflyBlue.x * clientWidth,
                  y: module17.rewards.ButterflyBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${ButterflyBlue})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.ButterflyPink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.ButterflyPink.x * clientWidth,
                  y: module17.rewards.ButterflyPink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${ButterflyPink})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.PlaygroundBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.PlaygroundBlue.x * clientWidth,
                  y: module17.rewards.PlaygroundBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveReward17'
                  style={{ backgroundImage: `url(${PlaygroundBlue})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.PlaygroundRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.PlaygroundRed.x * clientWidth,
                  y: module17.rewards.PlaygroundRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveReward27'
                  style={{ backgroundImage: `url(${PlaygroundRed})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.Baseball.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.Baseball.x * clientWidth,
                  y: module17.rewards.Baseball.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveSmallReward17'
                  style={{ backgroundImage: `url(${Baseball})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.Ball.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.Ball.x * clientWidth,
                  y: module17.rewards.Ball.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveSmallReward27'
                  style={{ backgroundImage: `url(${Ball})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.PondMallardDuck.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.PondMallardDuck.x * clientWidth,
                  y: module17.rewards.PondMallardDuck.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='movePond1'
                  style={{ backgroundImage: `url(${PondMallardDuck})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.PondWhiteDuck.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.PondWhiteDuck.x * clientWidth,
                  y: module17.rewards.PondWhiteDuck.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='movePond2'
                  style={{ backgroundImage: `url(${PondWhiteDuck})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.KitePink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.KitePink.x * clientWidth,
                  y: module17.rewards.KitePink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${KitePink})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.KitePurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.KitePurple.x * clientWidth,
                  y: module17.rewards.KitePurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${KitePurple})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.SkateboardRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.SkateboardRed.x * clientWidth,
                  y: module17.rewards.SkateboardRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveSkateboard1'
                  style={{ backgroundImage: `url(${SkateboardRed})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.SkateboardBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.SkateboardBlue.x * clientWidth,
                  y: module17.rewards.SkateboardBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveSkateboard2'
                  style={{ backgroundImage: `url(${SkateboardBlue})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.DogInBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.DogInBlue.x * clientWidth,
                  y: module17.rewards.DogInBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${DogInBlue})` }}
                ></div>
              </Draggable>
            )}

            {module17.rewards.DogInRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module17.rewards.DogInRed.x * clientWidth,
                  y: module17.rewards.DogInRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${DogInRed})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module17World;
